import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, Alert, Spinner } from 'react-bootstrap';
import { updateAccountTickerNextPlan } from '../services/api';

const NextPlanEditor = ({
  show,
  onHide,
  ticker,
  accountId,
  onChange
}) => {
  const [action, setAction] = useState('HOLD');
  const [sizePct, setSizePct] = useState(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (ticker) {
      setAction(ticker.next_action || 'HOLD');
      setSizePct(ticker.next_size_pct ?? null);
      setError('');
    }
  }, [ticker]);

  const handleSave = async () => {
    if (!ticker || !accountId) return;
    setSaving(true);
    setError('');
    try {
      const payload = { action };
      if (action === 'ADD' || action === 'TRIM') {
        const finalSize = sizePct ?? 0.5;
        payload.size_pct = finalSize;
      }
      await updateAccountTickerNextPlan(ticker.ticker_id, accountId, payload);
      if (onChange) {
        onChange({ ...ticker, next_action: payload.action, next_size_pct: payload.size_pct ?? null });
      }
      onHide && onHide();
    } catch (e) {
      setError('Failed to save. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  const sizeDisabled = action === 'HOLD' || action === 'EXIT';

  return (
    <Modal show={show} onHide={onHide} centered backdrop="static" size="sm">
      <Modal.Header closeButton>
        <Modal.Title>Next Plan for {ticker?.symbol}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && (
          <Alert variant="danger" className="py-1 mb-2">{error}</Alert>
        )}
        <Row className="mb-3">
          <Col xs={5} className="d-flex align-items-center">Action</Col>
          <Col xs={7}>
            <Form.Select
              size="sm"
              value={action}
              onChange={(e) => setAction(e.target.value)}
            >
              <option value="ADD">Add</option>
              <option value="HOLD">Hold</option>
              <option value="TRIM">Trim</option>
              <option value="EXIT">Exit</option>
            </Form.Select>
          </Col>
        </Row>
        <Row>
          <Col xs={5} className="d-flex align-items-center">Size</Col>
          <Col xs={7}>
            <Form.Select
              size="sm"
              value={sizePct ?? 0.5}
              onChange={(e) => setSizePct(e.target.value ? parseFloat(e.target.value) : null)}
              disabled={sizeDisabled}
            >
              <option value={0.25}>1/4x</option>
              <option value={0.5}>1/2x</option>
              <option value={1}>1x</option>
            </Form.Select>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={onHide} disabled={saving}>
          Cancel
        </Button>
        <Button
          variant={action === 'ADD' ? 'success' : (action === 'HOLD' ? 'light' : 'danger')}
          size="sm"
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? (<><Spinner animation="border" size="sm" className="me-2" />Saving...</>) : 'Save'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default NextPlanEditor;


